function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19ZM11 14.6C11 14.8209 10.8209 15 10.6 15H9.4C9.17909 15 9 14.8209 9 14.6V11H5.4C5.17909 11 5 10.8209 5 10.6V9.4C5 9.17909 5.17909 9 5.4 9L9 9L9 5.4C9 5.17909 9.17909 5 9.4 5H10.6C10.8209 5 11 5.17909 11 5.4L11 9H14.6C14.8209 9 15 9.17909 15 9.4V10.6C15 10.8209 14.8209 11 14.6 11H11V14.6Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedical);
export default __webpack_public_path__ + "static/media/icon-medical.70250688f316b8bd1aefdb55bd41b8a4.svg";
export { ForwardRef as ReactComponent };